<template>
	<div class="row col-12 table-row">
		<h2 class="col-12 table-header">{{tableData.name}}</h2>
		<div class="table-container row col-12 px-0">
			<table class="col-12 reno-table">
				<thead>
					<tr>
						<th>Brand/Supplier</th>
						<th>Process</th>
						<th>Additional information</th>
						<th>Member Access</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(row, index) of tableData.rows" :key="index">
						<td><p v-html="row.brand"></p><p v-if="row.partner !== ''"><i>{{toTitleCase(row.partner)}} Supplier</i></p></td>
						<td v-html="row.process"></td>
						<td v-html="row.info"></td>
						<td>
							<p v-if="row.available.silver" class="silver">Silver<span v-if="row.available.limited_silver">(Limited)</span></p>
							<p v-if="row.available.gold" class="gold">Gold</p>
							<p v-if="row.available.platinum" class="platinum">Platinum</p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>

export default {
	name: 'RenovationsTable',
	props: ["tableData"],
	components: {

	},
	methods: {
		toTitleCase(str) {
			return str.replace(/\w\S*/g, function(txt){
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.table-header {
	text-align: center;
}

.table-row {
	margin-bottom: 30px;
}

.table-container {
	overflow-x: scroll;
}

.reno-table {
	border-collapse: collapse;
	thead tr, tr:nth-child(2n){
		background-color: #f6f6f6;
	}
	th, td {
		border: 1px solid #eaeaea;
		// max-width: 110px;
		// height: 70px;
		padding: 10px;
	}

	td:first-child {
		width: 200px;
		i {
			color: $CTgreen;
			font-weight: bold;
		}
	}

	td:last-child{ 
		text-align: center;
		width: 150px;
		p {
			font-weight: bold;
			&.silver {
				color: $CTSilver;
			}
			&.gold {
				color: $CTgold;
			}
			&.platinum {
				color: $CTPlatinum;
			}
		}
	}

	thead {
		text-align: center;
		color: #fff;
		th {
			background-color: $CTred;
		}
	}

}
</style>
